import { Alert, Button, Modal } from "react-bootstrap";
import { accept, reject } from "../../utils/api";

export default function Model({
  seS,
  seM,
  eM,
  eS,
  S,
  server,
  id,
  qs,
  HH, // Fixed the order of props
}: Componate) {
  return (
    <>
      <Modal show={S} onHide={() => HH(false)} style={{ width: "100%" }}>
        <Alert variant="danger" show={eS}>
          {eM}
        </Alert>
        <Modal.Header closeButton>
          <Modal.Title className="text text-dark">
            The reply for the user: {id}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <form>
            <div className="mb-3">
              {Object.keys(qs)?.map((q, index) => (
                <div key={index}>
                  <p className="fw-bold text text-dark">{q}</p>
                </div>
              ))}
            </div>
          </form>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => HH(false)}>
            Close
          </Button>
          <Button
            variant="primary"
            onClick={() =>
              accept(id, server)
                .then(() => (window.location.href = `/server/${server}/applys`))
                .catch((res) => {
                  seS(true);
                  seM(res?.response?.data || "errors");
                })
            }
          >
            Accept
          </Button>
          <Button
            variant="danger"
            onClick={() =>
              reject(id, server)
                .then(() => (window.location.href = `/server/${server}/applys`))
                .catch((res) => {
                  seS(true);
                  seM(res?.response?.data || "errors");
                })
            }
          >
            Reject
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
}

type Componate = {
  seM: (type: string) => void;
  seS: (type: boolean) => void;
  HH: (type: boolean) => void;
  eM: string;
  eS: boolean;
  S: boolean;
  server: string;
  id: string;
  qs: string[]; // Changed from string[] to string
};
